<template>
  <div>
    <div class="card card--white" v-if="step === 'start'">
      <div class="card card--container">
        <h3>New Pulse Survey</h3>
        <h-input label="What is the name of the survey?" v-model="survey.name"/>
        <h-btn @click="create" class="small-top">Save</h-btn>
      </div>
    </div>
  </div>
</template>

<script>
import newQuestion from "./questions";
import dataStore from "@/services/api/store";

const PULSE_SURVEY_STORE = "CoachPulseSurveys";

export default {
  components: {
    newQuestion
  },
  data() {
    return {
      step: "start",
      survey: {},
      questions: []
    };
  },
  methods: {
    create() {
      dataStore.create(PULSE_SURVEY_STORE, this.survey).then(survey => {
        this.$router.push({
          name: "pulseSurveyDetail",
          params: { id: survey.id }
        });
      });
    }
  }
};
</script>

<style>
</style>
